import type { QuestionFilters, SessionOption } from './question-filters'
import { useQuery } from '@apollo/client/react'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { GQL_GROUPS } from '~/gql/groups/groups'
import { GQL_SESSIONS } from '~/gql/sessions/sessions'
import { filtersFromUrl, knownFilters, moduleOptions, withFilter } from './question-filters'

/**
 * Filtres de l'analyse par question (#159) et leurs choix. Les modules viennent
 * des parcours, comme le filtre des statistiques : l'accès aux statistiques
 * comprend la lecture des parcours, pas celle du catalogue de modules.
 */
export function useQuestionFilters() {
  const [searchParams] = useSearchParams()
  const [requested, setFilters] = useState<QuestionFilters>(() => filtersFromUrl(searchParams))
  const { data: sessionsData, error: sessionsError } = useQuery(GQL_SESSIONS)
  const { data: groupsData } = useQuery(GQL_GROUPS)
  const sessions = (sessionsData?.sessions ?? []) as SessionOption[]
  const filters = knownFilters(requested, sessionsData || sessionsError ? sessions : null)

  return {
    filters,
    set: <K extends keyof QuestionFilters>(key: K) => (value: QuestionFilters[K]) =>
      setFilters(withFilter(filters, key, value, sessions)),
    sessions,
    groups: groupsData?.groups ?? [],
    modules: moduleOptions(sessions, filters.sessionId),
  }
}
